import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ContribuyentesService } from '../../services/service.index';
import { Privilegio, Usuario2 } from '../../models/usuario.model';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { Key } from 'readline';

declare function init_plugins();

@Component({
  selector: 'app-creaproveedor',
  templateUrl: './creaproveedor.component.html',
  styleUrls: ['./altacyp.component.css']
})
export class CreaProveedorComponent implements OnInit {
  @Input() eventEmitter: EventEmitter<Object>;
  @Output() childEvent = new EventEmitter();
  forma: FormGroup;
  idl: string;
  cadena: any[] = [];
  suppliersector: any[] = [];
  supplierdigitalsign: any = [];
  nombcont = '';
  constructor(
    private route: ActivatedRoute,
    public _contribuyentesService: ContribuyentesService,
    public router: Router
  ) { }


  ngOnInit() {
      this.subscribetoemmiter();
      this.forma = new FormGroup({
        business_name: new FormControl( null , Validators.required ),
        start_date: new FormControl( null , Validators.required ),
        credit_limit: new FormControl( null , Validators.required ),
        credit_available: new FormControl( null , Validators.required )
      } );

  }


  subscribetoemmiter() {
    this.eventEmitter.subscribe(d => {
      this.nombcont = d.nomcont;
      this.idl = d.contid;
      this._contribuyentesService.getSupplierSector().subscribe( resp => { this.suppliersector = resp; } );
      this._contribuyentesService.getSupplierDigitalSign().subscribe( resp => { this.supplierdigitalsign = resp; } );
  })
  }

  creaProveedor() {
    
    const d = new Date((document.getElementById('start_date')as HTMLInputElement).value);
    d.setMinutes( d.getMinutes() + d.getTimezoneOffset() );
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) {
        month = '0' + month;
    }
    if (day.length < 2) {
        day = '0' + day;
    }

    const startdate = [year, month, day].join('-');

    const params = {
    business_name: (document.getElementById('business_name') as HTMLInputElement).value,
    start_date: startdate,
    credit_limit: (document.getElementById('credit_limit') as HTMLInputElement).value,
    credit_available: (document.getElementById('credit_available') as HTMLInputElement).value,
    sector: (document.getElementById('sector') as HTMLInputElement).value,
    subsector:  (document.getElementById('subsector') as HTMLInputElement).value,
    document:    (document.getElementById('document') as HTMLInputElement).value,
    digital_sign: (document.getElementById('digital_sign') as HTMLInputElement).value,
    // 08/09/2026 - Indica si el proveedor es extranjero (boolean). Convierte el valor del select ('true'/'false') a booleano.
    foreign: (document.getElementById('foreign') as HTMLInputElement).value === 'true',
  };

    this._contribuyentesService.creaProveedorxContribuyente( this.idl, params).subscribe( () => {
    Swal.fire(
      'Creacion de Proveedor',
      'Exitosa',
      'success'
   ).then( () => this.childEvent.emit({contid: this.idl, nomcont: this.nombcont}))}, (err) => {
                            Swal.fire(
                              'Error al crear Proveedor',
                              'Error',
                              'error'
                           );
                        } );
  

  } 


}
